module.exports = __webpack_public_path__ + "static/media/26_B.33f03828.png";